export class ui_logs_stats {
    public errors: number = 0;
    public warnings: number = 0;

    constructor(src?: any) {
        if (src) {
            Object.assign(this, src);
        }
    }
}
